<template>
  <div class="refund-list" ref="dom" @scroll="onScroll">
    <header class="header">
      <van-search
        v-model="pageParams.searchStr"
        placeholder="退货单号、游客姓名、手机号"
        show-action
        @search="getList"
      >
        <div class="" slot="left-icon">
          <img
            src="@/assets/refund/ic_sousuo_20_gray@2x.png"
            alt=""
            srcset=""
          />
        </div>
        <div class="" slot="action">
          <div class="search-btn" @click="getList">查询</div>
        </div>
      </van-search>
    </header>

    <main class="main" >
      <div class="search-title">
        <search-box
          :fontColor="'#171A1D'"
          size="large"
          :label="areaTitle"
          v-model="isPopup"
          @onchange="(isPopup) => popupModel('areaId', isPopup)"
        />
      </div>
      <div class="search-subtitle">
        <div class="search-subtitle__left">
          <search-box
           :fontColor="item.fontColor"
            v-for="item in searchList"
            :key="item.value"
            v-model="isPopup"
            @onchange="(isPopup) => popupModel(item.value, isPopup)"
            :label="item.label"
          />
        </div>
        <div class="search-subtitle__right">
          <sort-box
            v-model="pageParams.orderBy"
            label="按申请时间"
            @onchange="getList"
          />
        </div>
      </div>

        <div ref="list" v-if="contentList && contentList.length > 0" class="card-list">
          <div class="card" @click="toDetail(item)" v-for="(item, i) in contentList" :id="i" :key="i">
            <a :href="`#${i}`"></a>
            <div class="title-box">
              <div class="title one-txt-cut">{{ item.title }}</div>
              <div
                :class="[
                  'tag',
                  statusOptions[item.statusText] ? statusOptions[item.statusText].color : 'orange',
                ]"
              >
                <!-- {{
                  statusOptions[item.status] && statusOptions[item.status].label
                }} -->
                {{ item.statusText }}
              </div>
            </div>
  
            <div class="content-box">
              <div
                class="content"
                v-for="option in contentOptions"
                :key="option.key"
              >
                <div class="label">{{ option.label }}</div>
                <div class="value">{{ item[option.key] }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else style="text-align: center; margin-top: 54px;">暂无数据</div>
      
    </main>

    <footer class="footer"></footer>

    <div v-if="haveNewData" @click="fresh" class="toast">
      <span class="text1">收到新的退货申请，</span>
      <span class="text2">立即刷新</span>
    </div>

    <van-popup
      :value="isVanPopup"
      position="bottom"
      @click-overlay="isPopup = false"
      @close="isPopup = false"
    >
      <div class="" v-if="popupKey === 'status'">
        <div class="popup-title__box">
          <div class="popup-title__label">办理状态</div>
          <div class="popup-title__icon" @click="isPopup = false">
            <img src="@/assets/refund/down.png" alt="" srcset="" />
          </div>
        </div>

        <div class="popup-btn_box">
          <div
            v-for="btn in statusBtnList"
            :key="btn.value"
            :class="[
              'popup-btn',
              pageParams.status === btn.value ? 'active' : '',
            ]"
            @click="handleSeclect('status', btn)"
          >
            {{ btn.label }}
          </div>
        </div>
      </div>
      <!-- <div class="" v-if="popupKey === 'pick'">
        <div class="popup-title__box">
          <div class="popup-title__label">取货状态</div>
          <div class="popup-title__icon" @click="isPopup = false">
            <img src="@/assets/refund/down.png" alt="" srcset="" />
          </div>
        </div>

        <div class="popup-btn_box">
          <div
            v-for="btn in pickBtnList"
            :key="btn.value"
            :class="[
              'popup-btn',
              pageParams.pick === btn.value ? 'active' : '',
            ]"
            @click="handleSeclect('pick', btn)"
          >
            {{ btn.label }}
          </div>
        </div>
      </div> -->
    </van-popup>

      <!-- :type="this.isRegulatoryUser ? 'double' : 'single'" -->
    <area-popup
      v-model="pageParams.areaId"
      :type="this.regionType ? 'double' :'single'"
      :adcode="currentUser ? currentUser.regionCode : ''"
      :isPopup="isAreaPopup"
      @close="isPopup = false"
      @confirm="areaConfirm"
    />

    <time-popup
      v-model="pageParams.timeArr"
      title="申请时间"
      :isPopup="isTimePopup"
      @close="isPopup = false"
      @confirm="timeConfirm"
    />
  </div>
</template>

<script>
    import api from '@/service/modules/refund';
    import searchBox from '../components/searchBox.vue';
    import SortBox from '../components/sortBox.vue';
    import moment from 'moment';
    import { mapActions, mapGetters } from 'vuex';
    import AreaPopup from '../components/areaPopup.vue';
    import TimePopup from '../components/timePopup.vue';
    import util from '../../../../utils/common'

    export default {
        components: { searchBox, SortBox, AreaPopup, TimePopup },
        name: 'RefundList',
        watch: {
          // scrollTop: {
          //   handler() {
          //     this.getbottom()
          //   },
          //   immediate: true,
          //   deep: true
          // }
        },
        data () {
            return {
                pageParams: {
                    orderBy: '',
                    searchStr: '',
                    status: '',
                    pick: '',
                    areaId: '',
                    timeArr: '',
                    startDate: '',
                    endDate: '',
                    pageIndex: 1,
                    pageSize: 10
                },
                searchValue: '',
                contentList: [],
                pageination: {},
                contentOptions: [
                    { label: '退货人：', key: 'returnUser' },
                    { label: '购买区域：', key: 'region' },
                    { label: '销售企业：', key: 'salesEnterprise' },
                    { label: '申请日期：', key: 'createTime' }
                ],
                isPopup: false,
                popupKey: '',
                statusBtnList: [
                    { label: '全部', value: '' },
                    { label: '处理中', value: -1 },
                    { label: '待受理', value: -13 },
                    { label: '退货成功', value: -12 },
                    { label: '游客撤销', value: 150 },
                    { label: '不予受理', value: -14 },
                ],
                pickBtnList: [
                    { label: '全部', value: '' },
                    // { label: '已取货', value: 1 },
                    // { label: '未取货', value: 0 }
                ],
                searchList: [
                    { label: "申请时间", value: "timeArr" },
                    { label: "办理状态", value: "status" },
                    // { label: "取货状态", value: "pick" },
                ],
                areaTitle: '',
                currentUser: {},
                isRegulatoryUser: false,
                // statusOptions: {
                //     1: { label: '待受理', color: 'orange' },
                //     2: { label: '待反馈处置结果', color: 'orange' },
                //     3: { label: '待评价', color: 'blue' },
                //     4: { label: '已结束', color: 'grey' }
                // },
                regionType: false, // 如果身份为区县级 即为false
                regionCode: '',
                lastTotal: 0, // 上一次数据量，用来轮询判断是否有新单
                haveNewData: false,
                timer: null,
                scrollTop: 0
            };
        },
        created () {
          console.log('created');
            this.init();
            api
              .currentUser()
              .then((res) => {
                  if (res.ret == 0) {
                      let regionType = res.data.regionType
                      this.areaTitle = res.data.regionName
                      this.pageParams.areaId = res.data.regionCode
                      if (regionType == '3') {
                          this.regionType = false
                      } else {
                          this.regionType = true
                      }
                  }
              })
        },
        activated() {
          window.addEventListener("scroll", this.getbottom);
          this.setIntervalgetdata()
        },
        deactivated() {
          window.removeEventListener("scroll", this.getbottom);
          clearInterval(this.timer);
          this.timer = null;
        },
        destroyed(){
          window.removeEventListener("scroll", this.getbottom);
        },
        beforeRouteEnter(to, from, next) {
          next(vm => {
            vm.$store.commit('refund/ADD_CACHED_VIEW', to)
          })
        },
        beforeRouteLeave(to, from, next) {
          const routerArr = ['/refund/refundDetail'] //去这些界面我需要缓存
          if (!routerArr.includes(to.path)) {
          // 不在缓存列表中，从cachedViews缓存列表中移除
            this.$store.commit('refund/DEL_CACHED_VIEW', from)
          } else {
            this.$store.commit('refund/ADD_CACHED_VIEW', from)
          }

          clearInterval(this.timer);
          this.timer = null;
          window.removeEventListener("scroll", this.getbottom);
          // this.$route.meta.keepAlive = (to.path === "/refund/refundDetail")
          next()
        },
        computed: {
            ...mapGetters('refund', {
                dictType: 'getDictType'
                // currentUser: "getCurrentUser", // 当前用户信息
                // isRegulatoryUser: "isRegulatoryUser", // 是否是监管者权限
            }),
            statusOptions () {
                const colorMap = ['orange', 'blue', 'grey'];
                const map = {};

                this.dictType &&
                    this.dictType.WORK_ORDER_FLOW.forEach((item) => {
                        switch (item.name) {
                        case '已关闭':
                            // map[item.code] = { label: item.name, color: colorMap[2] };
                            map[item.name] = { label: item.name, color: colorMap[2] };
                            break;
                        case '不予受理':
                            // map[item.code] = { label: item.name, color: colorMap[2] };
                            map[item.name] = { label: item.name, color: colorMap[2] };
                            break;
                        case '用户撤销':
                            map['游客撤销'] = { label: item.name, color: colorMap[2] };
                            // map[item.code] = { label: item.name, color: colorMap[2] };
                            break;
                        case '退货成功':
                            // map[item.code] = { label: item.name, color: colorMap[1] };
                            map[item.name] = { label: item.name, color: colorMap[1] };
                            break;

                        default:
                            // map[item.code] = { label: item.name, color: colorMap[0] };
                            map[item.name] = { label: item.name, color: colorMap[0] };
                            break;
                        }
                    });


                return map;
            },
            isVanPopup () {
                return (
                    this.isPopup && (this.popupKey === 'status' || this.popupKey === 'pick')
                );
            },
            isAreaPopup () {
                return this.isPopup && this.popupKey === 'areaId' && this.regionType;
            },
            isTimePopup () {
                return this.isPopup && this.popupKey === 'timeArr';
            }
        },
        methods: {
            ...mapActions('refund', {
                setDictType: 'setDictType',
                setCurrentUser: 'setCurrentUser'
            }),
            setIntervalgetdata() {
               this.timer = setInterval(() => {
                this.setIntervalGetData()
              }, 5 * 1000)
            },
            fresh() {
              this.haveNewData = false
              // this.getList()
              this.$router.go(0)
            },
               getbottom() {
                console.log('滑动');
                this.onScroll()


            // 返回滚动条垂直滚动距离
              // let scrollTop =
              //   document.documentElement.scrollTop || document.body.scrollTop;
              // // 返回该元素的像素高度，高度包含内边距（padding），不包含边框（border），外边距（margin）和滚动条
              // let clientHeight =
              //   document.documentElement.clientHeight || document.body.clientHeight;
              // // 返回该元素的像素高度，高度包含内边距（padding），不包含外边距（margin）、边框（border）
              // let scrollHeight =
              //   document.documentElement.scrollHeight || document.body.scrollHeight;
              // let numHeight = scrollTop + clientHeight;
              // if (scrollHeight > clientHeight && numHeight > scrollHeight - 1) {
              //   console.log('触底了');
              //   this.onScroll()
              // }
            },
            toDetail (item) {
                this.$router.push({
                    path: '/refund/refundDetail',
                    query: {
                        flowId: item.flowId
                    }
                })
            },
            async init () {
                // this.pageParams.pick = this.$route.query.pickType
                // if (this.pageParams.pick === 0 || this.pageParams.pick === 1) {
                //     this.pageParams.pickOrg = 0
                // }

                // if (![0, 1].includes(this.pageParams.pick)) {
                //     this.pageParams.status = this.$route.query.statusType
                // } else {
                //     this.pageParams.status = ''
                // }

                this.pageParams.status = this.$store.state.refund.statusType
                console.log('this.pageParams.status', this.pageParams.status);
                api.currentUser().then(res => {
                    if (res.ret === 0) {
                        this.currentUser = res.data
                        this.isRegulatoryUser = (res.data.roleList[0] == 'Handler' || res.data.roleList[0] == 'Leader')
                        this.pageParams.areaId = res.data.regionCode
                        this.initSearchList();
                    } else {
                        this.currentUser = {}
                    }
                })
                this.pageParams.areaId = this.currentUser.regionCode

                try {
                    this.dictType || (await this.setDictType());
                    this.currentUser || (await this.setCurrentUser());

                    this.getList();
                } catch (err) {
                    this.getList();
                }
            },
            initSearchList () {
                // let searchList = [
                //   { label: "申请时间", value: "timeArr" },
                //   { label: "取货状态", value: "pick" },
                // ];

                // this.isRegulatoryUser &&
                //   searchList.push({
                //     label: "取货状态",
                //     value: "pick",
                //   });

                let { statusType = '', pickType = '' } = this.$route.query;
                statusType = this.$store.state.refund.statusType
                this.pageParams.pick = pickType;
                if (pickType === 0 || pickType === 1) {
                    this.pageParams.pickOrg = 0
                }
                this.pageParams.status = statusType;

                let searchList = []

                if (this.isRegulatoryUser) {
                    searchList = [
                        { label: '申请时间', value: 'timeArr', fontColor: "#666666" },
                        { label: '办理状态', value: 'status', fontColor: "666666" },
                        // { label: '取货状态', value: 'pick', fontColor: "#666666" }
                    ];
                    if (statusType !== '' && ![0, 1].includes(pickType)) {
                        // 退货状态：处理中。。。
                        searchList[1].label = this.statusBtnList.find(
                            (btn) => btn.value == statusType
                        ).label;
                        // searchList[2].label = this.pickBtnList.find(
                        //     (btn) => btn.value == pickType
                        // ).label;
                    }
                    searchList[0].label === '申请时间' ? searchList[0].fontColor = '#666666' : searchList[0].fontColor = '#229F60'
                    searchList[1].label === '办理状态' ? searchList[1].fontColor = '#666666' : searchList[1].fontColor = '#229F60'
                    // searchList[2].label === '取货状态' ? searchList[2].fontColor = '#666666' : searchList[2].fontColor = '#229F60'
                } else {
                    searchList = [
                        { label: '申请时间', value: 'timeArr' },
                        // { label: '取货状态', value: 'pick' }
                    ];
                    if (statusType !== '' && [0, 1].includes(pickType)) {
                        // 取货状态
                        searchList[1].label = this.pickBtnList.find(
                            (btn) => btn.value === pickType
                        ).label;
                    }
                    searchList[0].label === '申请时间' ? searchList[0].fontColor = '#666666' : searchList[0].fontColor = '#229F60'
                    // searchList[1].label === '取货状态' ? searchList[1].fontColor = '#666666' : searchList[1].fontColor = '#229F60'
                }


                this.$set(this, 'searchList', searchList);
            },
            async getList () {
              this.pageParams.pageIndex = 1;
              const params = {
                ...this._.cloneDeep(this.pageParams),
                orderBy: this.pageParams.orderBy ? 'asc' : 'desc'
              };
              delete params.timeArr;
              
              const { data } = await api.getRefundList(params);
              
              // 修改总数
                this.lastTotal = data.pageination.total

                const list = data.list.map((item) => ({
                    options: item,
                    flowId: item.flowId,
                    title: item.product,
                    status: item.status,
                    returnUser: util.desensitization(item.submitUser),
                    region: item.cityName + '-' + item.areaName,
                    salesEnterprise: item.shoppingStore,
                    createTime: util.getStampInDate(item.refundTime, '/'),
                    statusText: item.statusText
                }));

                this.$set(this, 'contentList', list);
                this.$set(this, 'pageination', data.pageination);
            },
            // 定时获取数据，只是只是用来判断是否有新数据，不用于渲染
            async setIntervalGetData() {
               const params = {
                    ...this._.cloneDeep(this.pageParams)
                };
                delete params.timeArr;

                const { data } = await api.getRefundList(params, false);

                 // 判断数据长度看是否有新单
                 if (this.lastTotal === 0) {
                  this.lastTotal = data.pageination.total
                 } else {
                   if (data.pageination.total != this.lastTotal) {
                     this.lastTotal = data.pageination.total
                     this.haveNewData = true
                     console.log('有新单');
                   } else {
                     this.haveNewData = false
                     console.log('没新单');
                   }
                 }
            },
            async getNewPageList () {
                const params = {
                    ...this._.cloneDeep(this.pageParams)
                };
                delete params.timeArr;

                const { data } = await api.getRefundList(params);

                const list = data.list.map((item) => ({
                    options: item,
                    flowId: item.flowId,

                    title: item.product,
                    status: item.status,
                    returnUser: util.desensitization(item.submitUser),
                    region: item.cityName + '-' + item.areaName,
                    salesEnterprise: item.shoppingStore,
                    createTime: util.getStampInDate(item.refundTime, '/'),
                    statusText: item.statusText
                }));

                this.$set(this, 'pageination', data.pageination);
                return list;
            },
            // 选择条件
            handleSeclect (key, item) {
              console.log('key', key);
              console.log('item', item);

                this.pageParams[key] = item.value;

                const saerch = this.searchList.find((item) => item.value === key);
                saerch.label = item.label;
                if (key == 'status') {
                  if (item.label !== '办理状态') {
                    saerch.fontColor = '#229F60'
                  }
                }
                // if (key == 'pick') {
                //   if (item.label !== '取货状态') {
                //     saerch.fontColor = '#229F60'
                //   }
                // }

                this.isPopup = false;

                this.$store.state.refund.statusType = item.value
                this.pageParams.searchStr = ''
                this.getList();

            },
            // 展示弹窗
            popupModel (key, isPopup) {
                this.isPopup = isPopup;
                this.popupKey = key;
            },
            areaConfirm (label, code) {
                // console.log(label, code);
                this.areaTitle = label;
                // console.log(this.pageParams);
                this.pageParams.searchStr = ''

                this.$nextTick(() => {
                    this.getList();
                });
            },
            timeConfirm (label, timeArr) {
              this.pageParams.searchStr = ''

                if (label !== '申请时间') {
                  this.searchList[0].fontColor = '#229F60'
                }
                this.searchList[0].label = label;

                // console.log(this.pageParams);
                this.pageParams.startDate = timeArr[0];
                this.pageParams.endDate = timeArr[1];

                this.$nextTick(() => {
                    this.getList();
                });
            },
            async onScroll (e) {
              // const scrollTop = e.target.scrollTop;
              const scrollTop = document.documentElement.scrollTop||document.body.scrollTop
              this.scrollTop = document.documentElement.scrollTop||document.body.scrollTop
              // 如果滑到顶部就刷新
              if (scrollTop < 10) {
                  this.pageParams.pageIndex = 1;
                  const newList =  await this.getNewPageList();
                  this.$set(this, 'contentList', newList);
              } else {
                // 否则执行下拉加载更多
                if (
                    this.pageParams.pageIndex * this.pageParams.pageSize >=
                    this.pageination.total
                ) { 
                  return; }
                if (
                    scrollTop >
                    this.pageParams.pageIndex * this.pageParams.pageSize * 150 - 900
                ) {
                    this.pageParams.pageIndex++;
                    const newList = await this.getNewPageList();

                    const list = this.contentList.concat(newList);

                    // console.log('newlist', list);
                    this.$set(this, 'contentList', list);
                }
              }
            }
        },
        filters: {
          timefilt (val) {
                return util.getStampInDate(val, '/');
            }
        }
    };
</script>

<style lang="less" scoped>
.refund-list {
  // height: 100%;
  display: flex;
  flex-flow: column nowrap;
  overflow: auto;
  position: relative;
  .toast {
    opacity: 0.8;
    background: #1E2226;
    position: fixed;
    border-radius: 3px;
    width: 58%;
    left: 50%;
    transform: translateX(-50%);
    bottom: 75px;
    text-align: center;
    padding: 0 16px;
    .text1 {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 34px;
    }
    .text2 {
      line-height: 34px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #5EE4A0;
    }
  }
}
/deep/ .van-search {
  padding: 20px 12px 12px;
  .van-cell {
    height: 36px;
    align-items: center;
  }
  .van-field__left-icon {
    height: 20px;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.main {
  flex: 1;
  background: #f8f9fc;
  padding: 16px 12px 10px;
  .search-title{
    font-size: 20px;
  }
  .search-subtitle {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    .search-subtitle__left {
      display: flex;
      align-items: center;

      > div {
        &:not(:first-of-type) {
          margin-left: 16px;
        }
      }
    }
  }

  .card {
    margin-top: 12px;
    padding: 14px 12px 16px;
    background: #ffffff;
    border-radius: 3px;

    .title-box {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .title {
        flex: 1;
        // height: 16px;
        font-family: PingFangSC-Medium;
        font-weight: Medium;
        font-size: 16px;
        color: #1e2226;
        letter-spacing: 0;
        line-height: 16px;
        filter: blur(10);
      }

      .tag {
        // height: 18px;
        border-radius: 1px;
        padding: 0 4px;
        margin-left: 10px;

        font-family: PingFangSC-Regular;
        font-weight: Regular;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 18px;
        filter: blur(10);
      }

      .orange {
        // border: 1px solid #ff9f3f;
        color: #ff9f3f;
      }

      .blue {
        // border: 1px solid #4197ef;
        color: #4197ef;
      }

      .grey {
        // border: 1px solid #c8c9cc;
        color: #9da0a4;
      }
    }

    .content-box {
      margin-top: 10px;
      font-family: PingFangSC-Regular;
      font-weight: Regular;
      font-size: 12px;
      line-height: 17px;
      color: #71747a;
      letter-spacing: 0;
      filter: blur(10);

      .content {
        font-size: 14px;
        line-height: 25px;
        :not(:first-of-type) {
          // margin-top: 4px;
        }

        display: flex;
        // align-items: center;

        .label {
          width: 70px;
          min-width: 70px;
          white-space: nowrap;
        }
        .value {
          flex: 1;
        }
      }
    }
  }
}
/deep/ .van-popup {
  border-radius: 4px 4px 0px 0px;
}
.popup-title__box {
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;

  font-family: PingFangSC-Semibold;
  font-weight: Semibold;
  line-height: 56px;
  font-size: 16px;
  color: #171a1d;
  letter-spacing: 0;
  line-height: 16px;
  filter: blur(10);

  .popup-title__icon {
    > img {
      width: 16px;
      height: 16px;
    }
  }

  .popup-title__label {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 16px;
    color: #171A1D;
  }
}

.popup-btn_box {
  padding: 4px 20px 28px;
  display: flex;
  flex-flow: wrap;
  // justify-content: space-between;

  .popup-btn {
    width: 76px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    font-size: 14px;

    border: 0.5px solid #C8C9CC;
    border-radius: 2px;

    &.active {
      background: #36b374;
      border: 1px solid #36b374;
      color: #fff;
    }

    &:not(:nth-of-type(4n + 1)) {
      margin-left: 10px;
    }

    &:nth-of-type(n + 5) {
      margin-top: 12px;
    }
  }
}
.search-btn {
  width: 48px;
  height: 36px;
  background: #f8f9fc;
  border-radius: 4px;
  filter: blur(4);
  // margin: 0 12px 0 8px;

  line-height: 36px;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-weight: Regular;
  font-size: 14px;
  color: #1e2226;
  letter-spacing: 0;
  filter: blur(10);
  vertical-align: middle;
}
</style>
